(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/assets/javascripts/views/pages/fractiongames-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/assets/javascripts/views/pages/fractiongames-page.js');

'use strict';

svs.eurojackpot.views.FractiongamesPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'eurojackpot',
    component: 'fractiongames'
  }],
  template() {
    return svs.eurojackpot.templates.fractiongames_page();
  },
  onDomRefresh() {
    if (svs.eurojackpot.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.render(React.createElement(svs.eurojackpot.components.fractiongames.FractiongamesApp, null), target);
    }
  },
  onDestroy() {
    if (svs.eurojackpot.components.fractiongames) {
      const target = document.getElementById('ngFractiongamesRegion');
      target && ReactDOM.unmountComponentAtNode(target);
    }
  }
});

 })(window);